import ManageApproved from "../../components/manage/ManageApproved";
import ManagePending from "../../components/manage/ManagePending";
import ManageProgress from "../../components/manage/ManageProgress";
import ManageRejected from "../../components/manage/ManageRejected";
import ManageUnits from "../../components/manage/ManageMatrix";
import ManageUsers from "../../components/manage/ManageUsers";
import Businesses from "./components/Businesses";
import flowchart from "../../assets/images/nflow.svg";
import Units from "../manage/units/Units";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { useNavigate } from "react-router";

export default function Dashboard() {
  const { auth } = useContext(AuthContext);
  const access = [4, 5, 9];
  const navigate = useNavigate();

  if (!access.includes(auth?.accessLevel)) {
    navigate("/requests");
  }
  return (
    <div className="">
      <div className="m-1">
        {access?.includes(auth?.accessLevel) && (
          <div className="">
            <div className="grid grid-cols-12 gap-1">
              <ManageUnits />
              <ManagePending />
              <ManageProgress />
              <ManageApproved />
              <ManageRejected />
              <ManageUsers />
            </div>

            <div className="my-1">
              <Businesses />
            </div>
          </div>
        )}
        <div className="grid grid-cols-12 gap-x-1">
          <div className="col-span-12 sm:col-span-8">
            <Units />
          </div>
          <div className="col-span-12 sm:col-span-4 bg-white">
            <div className="">
              <div className="border-b-4 pb-2 pt-4 px-4 font-bold mb-2 flex justify-between">
                <div className="">
                  <div className="text-fish">APPROVAL FLOW</div>
                  <div className="">Flow chart of the approval process</div>
                </div>
              </div>
              <div className="px-2 pb-4 flex justify-center items-center">
                <img src={flowchart} alt="" width={""} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
